<template>
  <div class="commoditysearch">
    <!-- 搜索框 -->
    <van-search
      v-model="datas.defaultValue"
      :show-action="datas.showAction"
      :shape="datas.shape"
      :label="datas.label"
      :input-align="datas.inputAlign"
      :background="datas.backgroundColor"
      :placeholder="datas.text"
      @search="handleSearch"
      @input="handleInput"
      @cancel="handleCancel"
    />
    <!-- 删除组件 -->
    <!-- <slot name="deles" /> -->
  </div>
</template>

<script>
export default {
  // name: "commoditysearch",
  props: {
    datas: Object,
  },
  created() {
    console.log("commoditysearch 组件创建了---111--111--11", this.datas);
  },
  data() {
    return {
      searchValue: this.datas.defaultValue,
    };
  },
  watch: {
    // 监听父组件传入的默认值变化
    defaultValue(newVal) {
      this.searchValue = newVal;
    },
  },
  methods: {
    // 搜索事件 - 透传给父组件
    handleSearch(value) {
      console.log("搜索事件 - 透传给父组件", value);
      this.$emit("search", value);
    },
    // 输入事件 - 透传给父组件
    handleInput(value) {
      console.log("输入事件 - 透传给父组件", value);
      this.$emit("input", value);
      this.searchValue = value;
    },
    // 取消搜索事件 - 透传给父组件
    handleCancel() {
      console.log("取消搜索事件 - 透传给父组件");
      this.$emit("cancel");
      this.searchValue = "";
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .van-search {
  width: 100%;
  padding: 5px;
  .van-search__content {
    .van-search__label {
      display: flex;
      align-items: center;
    }
    .van-cell {
      .van-field__left-icon {
        display: flex;
        align-items: center;
      }
    }
  }
}
.commoditysearch {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  /* 适配小程序端的默认样式重置 */
  width: 100%;
  /* 搜索框 */
  .searchs {
    position: relative;
    width: 345px;
    min-height: 28px;
    margin: 5px auto;
    display: flex;
    align-items: center;
    font-size: 14px;
    .search-left {
      display: flex;
      align-items: center;
    }
    .sweep {
      position: absolute;
      right: 10px;
    }
    i {
      margin: 0 5px;
    }
  }
}
</style>
